import React from 'react';
import { CalendarDropdownPrimitives } from '../../calendar-dropdown/CalendarDropdownPrimitives';
import { noop } from 'lodash';

type AllocationAsOfDateDropdownPlaceholderProps = {
  lastSelectedDate: string | undefined;
  lastFormattedDisplayDate: string | undefined;
  triggerSize: 'small' | 'normal';
};

export const AllocationAsOfDateDropdownPlaceholder = ({
  lastSelectedDate,
  lastFormattedDisplayDate,
  triggerSize,
}: AllocationAsOfDateDropdownPlaceholderProps) => {
  return (
    <CalendarDropdownPrimitives.Root selectedDate={lastSelectedDate ?? ''} onValueChange={noop} disabled>
      <CalendarDropdownPrimitives.Trigger formattedDisplayDate={lastFormattedDisplayDate ?? ''} size={triggerSize} />
    </CalendarDropdownPrimitives.Root>
  );
};
